import { createAction, props } from '@ngrx/store';
import dayjs from 'dayjs';

// TODO: check if this is model is good?
import { Entity, IncomingEntity } from 'src/app/theme/pages/default/plex/entities/entities.model';
import { environment } from '../../../environments/environment';

function convertDate(date) {
	const idealDateFormat = 'DD/MM/YYYY';

	if (date) {
		if (date.seconds) {
			return dayjs(date.toDate()).format(idealDateFormat);
		}

		if (typeof date === 'object') {
			return dayjs(date).format(idealDateFormat);
		}

		if (typeof date === 'string') {
			console.warn(`[Noldor Standards] Found "${date}" stored as a string, it is standard to save these as dates.`);

			if (dayjs(date, idealDateFormat).isValid()) {
				return date;
			}
		}

		console.warn(`[Noldor Standards] Could not convert "${date}", it is standard to save these as dates.`);
	}

	return '';
}

export const setEntityId = createAction('[Entity] Set entity id', props<{ entityId: string }>());
export const setEntityData = createAction('[Entity] Set enitity data', (incomingEntity: IncomingEntity | Entity) => {
	const entity = incomingEntity ?? {};
	const entityData = {
		...entity,
		incorporation_date: convertDate(entity?.incorporation_date) ?? '',
		dateTakeOn: convertDate(entity?.dateTakeOn),
		ownBankAccountDate: convertDate(entity?.ownBankAccountDate),
		agmDate: convertDate(entity?.agmDate),
		fireServiceDate: convertDate(entity?.fireServiceDate),
		previousAgmDate: convertDate(entity?.previousAgmDate),
		sgmDate: convertDate(entity?.sgmDate),
		previousSgmDate: convertDate(entity?.previousSgmDate),
		executiveMeetingDate: convertDate(entity?.executiveMeetingDate),
		previousExecutiveMeetingDate: convertDate(entity?.previousExecutiveMeetingDate),
		clientWebsiteUrl: entity?.domain ? `https://${entity.domain}.${environment.client}` : '',
	};
	return { entityData };
});
export const setEntityWhitfieldsPrefix = createAction('[Entity] Set entity whitfields prefix', props<{ whitfieldsPrefix: string }>());
export const setProductAllowedEntities = createAction('[Entity] Set product allowed entities', props<{ allowedEntities: string[] }>());
